export default __webpack_public_path__ + "static/media/pharmaceuticals.be969c34.jpg";